(function () {
  const initSlider = (section) => {
    const slider = section.querySelector(".multicolumn-grid");

    if (!slider || slider.swiper) return;

    const wrapper = slider.querySelector(".multicolumn-grid__wrapper");
    const slides = wrapper.querySelectorAll(".multicolumn-card");

    slider.classList.add("swiper");
    wrapper.classList.add("swiper-wrapper");
    slides.forEach((s) => s.classList.add("swiper-slide"));

    const nextBtn = section.querySelector(".multicolumn-swiper__button--next");
    const prevBtn = section.querySelector(".multicolumn-swiper__button--prev");
    const paginationEl = section.querySelector(
      ".multicolumn-swiper__pagination"
    );

    if (paginationEl && paginationEl.querySelector(".swiper-pagination-lock")) {
      paginationEl.style.display = "none";
    } else if (paginationEl) {
      paginationEl.style.display = "";
    }

    // If there's nothing to slide, hide controls and skip initializing Swiper
    if (slides.length <= 1) {
      if (paginationEl) paginationEl.style.display = "none";
      if (nextBtn) nextBtn.style.display = "none";
      if (prevBtn) prevBtn.style.display = "none";
      return;
    }

    new Swiper(slider, {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 16,
      speed: 800,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      pagination: {
        el: paginationEl,
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        576: {
          spaceBetween: 20,
        },
      },
    });
  };

  const destroySlider = (section) => {
    const slider = section.querySelector(".swiper--multicolumn");

    if (!slider || !slider.swiper) return;

    slider.swiper.destroy(true, true);

    const wrapper = slider.querySelector(".swiper-wrapper");
    const slides = slider.querySelectorAll(".multicolumn-card");

    slider.classList.remove("swiper");
    wrapper.classList.remove("swiper-wrapper");
    slides.forEach((s) => s.classList.remove("swiper-slide"));
  };

  const initMulticolumn = (section) => {
    if (!section?.classList.contains("multicolumn-section")) return;

    const box = section.querySelector(".multicolumn");
    if (!box) return;

    const hasMobileSlider = box.dataset.enableMobileSlider === "true";
    const hasDesktopSlider = box.dataset.enableDesktopSlider === "true";

    const resizeHandler = () => {
      const width = box.clientWidth;

      const shouldInit =
        (width < 576 && hasMobileSlider) || (width >= 576 && hasDesktopSlider);

      if (shouldInit) {
        initSlider(section);
      } else {
        destroySlider(section);
      }
    };

    const observer = new ResizeObserver(resizeHandler);
    observer.observe(box);
    resizeHandler();
  };

  initMulticolumn(document.currentScript.closest(".multicolumn-section"));

  document.addEventListener("shopify:section:load", function (event) {
    initMulticolumn(event.target);
  });
})();
